import React from 'react';

const HistorialFormulasModal = ({ patient, records = [], onSelectRecord, onClose }) => {
    if (!patient) return null;

    const sortedRecords = [...records].sort((a, b) => new Date(b.date || b.created_at) - new Date(a.date || a.created_at));

    return (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 10050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
            <div style={{ backgroundColor: '#ffffff', borderRadius: '16px', width: '900px', maxWidth: '100%', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
                
                {/* Header */}
                <div style={{ padding: '20px 24px', backgroundColor: '#111827', color: '#ffffff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h4 style={{ margin: 0, fontWeight: '800', fontSize: '1.2rem' }}>
                            <i className="bi bi-clock-history me-2"></i> Evolución y Fórmulas Anteriores
                        </h4>
                        <div style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '3px' }}>
                            Paciente: <strong>{patient.first_name} {patient.last_name}</strong> {patient.cedula ? `| C.I: ${patient.cedula}` : ''}
                        </div>
                    </div>
                    <button 
                        onClick={onClose} 
                        style={{ background: 'transparent', border: 'none', color: '#ffffff', fontSize: '1.5rem', lineHeight: 1, cursor: 'pointer', padding: '4px' }}
                    >
                        &times;
                    </button>
                </div>

                {/* Content */}
                <div style={{ padding: '20px 24px', overflowY: 'auto', flex: 1, backgroundColor: '#f9fafb' }}>
                    {sortedRecords.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#6b7280' }}>
                            <i className="bi bi-journal-x" style={{ fontSize: '3rem', opacity: 0.4 }}></i>
                            <h5 style={{ marginTop: '12px', fontWeight: '700' }}>No hay recetas ópticas previas registradas</h5>
                            <p style={{ fontSize: '0.9rem' }}>Las fórmulas de exámenes visuales anteriores se listarán aquí para comparar la progresión dióptrica.</p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                            {sortedRecords.map((rec, index) => {
                                const recordDate = rec.date || (rec.created_at ? rec.created_at.split('T')[0] : 'S/F');
                                // "Más reciente" = la última historia válida; las anuladas se muestran, marcadas.
                                const isLatest = !rec.anulada && sortedRecords.find(r => !r.anulada) === rec;

                                return (
                                    <div 
                                        key={rec.id || index}
                                        style={{
                                            backgroundColor: '#ffffff',
                                            borderRadius: '12px',
                                            border: isLatest ? '1.5px solid #111827' : '1px solid #e5e7eb',
                                            padding: '16px 20px',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                                            position: 'relative'
                                        }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', borderBottom: '1px solid #f3f4f6', paddingBottom: '8px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <span style={{ fontWeight: '800', color: '#111827', fontSize: '1rem' }}>
                                                    Fecha: {recordDate}
                                                </span>
                                                {rec.folio_number && (
                                                    <span style={{ backgroundColor: '#f3f4f6', color: '#374151', padding: '2px 8px', borderRadius: '6px', fontSize: '0.75rem', fontWeight: 'bold' }}>
                                                        Folio #{rec.folio_number}
                                                    </span>
                                                )}
                                                {rec.anulada && (
                                                    <span title={`Motivo: ${rec.motivo_anulacion || '—'}`} style={{ backgroundColor: '#fee2e2', color: '#991b1b', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 'bold', border: '1px solid #fecaca' }}>
                                                        ANULADA
                                                    </span>
                                                )}
                                                {isLatest && (
                                                    <span style={{ backgroundColor: '#10b981', color: '#ffffff', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 'bold' }}>
                                                        Más Reciente
                                                    </span>
                                                )}
                                            </div>
                                            {onSelectRecord && (
                                                <button 
                                                    onClick={() => onSelectRecord(rec)}
                                                    style={{ background: 'transparent', border: '1.5px solid #111827', color: '#111827', borderRadius: '6px', padding: '4px 12px', fontSize: '0.8rem', fontWeight: 'bold', cursor: 'pointer' }}
                                                >
                                                    Ver / Cargar Ficha
                                                </button>
                                            )}
                                        </div>

                                        {/* Tabla de Graduación RX */}
                                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center', fontSize: '11px', marginBottom: '8px' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#f3f4f6', color: '#111827', fontWeight: 'bold' }}>
                                                    <th style={{ padding: '6px', width: '10%' }}>Ojo</th>
                                                    <th style={{ padding: '6px', width: '18%' }}>Esfera</th>
                                                    <th style={{ padding: '6px', width: '18%' }}>Cilindro</th>
                                                    <th style={{ padding: '6px', width: '14%' }}>Eje</th>
                                                    <th style={{ padding: '6px', width: '14%' }}>Add</th>
                                                    <th style={{ padding: '6px', width: '13%' }}>AVL</th>
                                                    <th style={{ padding: '6px', width: '13%' }}>AVC</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                                                    <td style={{ fontWeight: 'bold', padding: '6px', backgroundColor: '#fafafa' }}>O.D</td>
                                                    <td style={{ fontWeight: 'bold', color: '#111827' }}>{rec.esfera_od || '-'}</td>
                                                    <td style={{ fontWeight: 'bold', color: '#111827' }}>{rec.cilindro_od || '-'}</td>
                                                    <td>{rec.eje_od ? `${rec.eje_od}°` : '-'}</td>
                                                    <td>{rec.add_od || '-'}</td>
                                                    <td>{rec.avl_od || '-'}</td>
                                                    <td>{rec.avc_od || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontWeight: 'bold', padding: '6px', backgroundColor: '#fafafa' }}>O.I</td>
                                                    <td style={{ fontWeight: 'bold', color: '#111827' }}>{rec.esfera_oi || '-'}</td>
                                                    <td style={{ fontWeight: 'bold', color: '#111827' }}>{rec.cilindro_oi || '-'}</td>
                                                    <td>{rec.eje_oi ? `${rec.eje_oi}°` : '-'}</td>
                                                    <td>{rec.add_oi || '-'}</td>
                                                    <td>{rec.avl_oi || '-'}</td>
                                                    <td>{rec.avc_oi || '-'}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* Especificaciones de lente y taller */}
                                        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', fontSize: '11px', color: '#4b5563', paddingTop: '4px' }}>
                                            {rec.tipo_lentes && <div><strong>Lente:</strong> {rec.tipo_lentes}</div>}
                                            {rec.tratamiento && <div><strong>Tratamiento:</strong> {rec.tratamiento}</div>}
                                            {rec.dp && <div><strong>D.P.:</strong> {rec.dp}</div>}
                                            {rec.profesional && <div><strong>Atendido por:</strong> {rec.profesional}</div>}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div style={{ padding: '14px 24px', backgroundColor: '#ffffff', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end' }}>
                    <button 
                        onClick={onClose} 
                        style={{ padding: '8px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: '#ffffff', color: '#374151', fontWeight: '600', cursor: 'pointer', fontSize: '0.9rem' }}
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HistorialFormulasModal;
